import { autoUpdate, flip, offset, size, useDismiss, useFloating } from '@floating-ui/react'
import { AnimatePresence } from 'framer-motion'
import { useQueryParams } from '@hooks'
import React, { useEffect, useState } from 'react'
import { NotificationBell } from './NotificationBell'
import { NotificationFeed } from './NotificationFeed'
import { NotificationPreferencesModal } from './NotificationPreferencesModal'

export const NotificationFeedPopup: React.FC = () => {
  const [isOpen, setOpen] = useState(false)
  const [prefsOpen, setPrefsOpen] = useState(false)
  const [params, setParams] = useQueryParams()
  const prefsDeepLink = Boolean(params.notification_preferences) || params.page === 'notifications'

  const { context, x, y, refs, strategy } = useFloating({
    open: isOpen,
    onOpenChange: setOpen,
    whileElementsMounted: autoUpdate,
    placement: 'bottom-end',
    middleware: [
      offset(20),
      flip(),
      size({
        apply: ({ availableWidth, availableHeight, elements }) => {
          const wPx = Math.min(availableWidth, 400)
          const hPx = Math.min(availableHeight, 600)
          Object.assign(elements.floating.style, {
            width: `${wPx}px`,
            maxHeight: `${hPx}px`
          })
        }
      })
    ]
  })

  useDismiss(context)

  useEffect(() => {
    if (!prefsDeepLink) {
      return
    }
    setPrefsOpen(true)
    setParams(
      {
        notification_preferences: undefined,
        ...(params.page === 'notifications' ? { page: undefined } : {})
      },
      { replace: true }
    )
  }, [prefsDeepLink])

  return (
    <>
      <div ref={refs.setReference} onClick={() => setOpen(!isOpen)}>
        <NotificationBell />
      </div>
      <AnimatePresence>
        {isOpen && !prefsOpen && (
          <NotificationFeed
            ref={refs.setFloating}
            onOpenPreferences={() => {
              setPrefsOpen(true)
              setOpen(false)
            }}
            style={{
              top: y || 0,
              left: x || 0,
              position: strategy
            }}
          />
        )}
      </AnimatePresence>
      <NotificationPreferencesModal isVisible={prefsOpen} onClose={() => setPrefsOpen(false)} />
    </>
  )
}
